import { IGetGameUrl } from '../../types/slot';
import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { ISlotegratorGetGameUrl, ISlotegratorServerGame } from '../../types/interfaces/Slots/Slotegrator';
import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { getTab, filterTab } from './utils';
import { CasinoType } from 'modules/Casino/types/configuration';

class Converter implements ISlotConverter {
  convertGameList = ({ data, platform }: IConvertGameList<ISlotegratorServerGame[]>): ISlotViewItem[] => {
    const mobileGames = data.filter(game => game.is_mobile === 1);
    const desktopGames = data.filter(game => game.is_mobile === 0);
    const haveTwoVersions = (game: ISlotegratorServerGame): boolean => {
      const isMobile = game.name.toLowerCase().includes('mobile');
      const secondVersion = isMobile
        ? desktopGames.find(item => item.name === game.name.slice(0, game.name.toLowerCase().indexOf('mobile') - 1))
        : mobileGames.find(item => item.name.slice(0, item.name.toLowerCase().indexOf('mobile') - 1) === game.name);
      if (secondVersion) return true;
      return false;
    };

    return data
      .filter(game => game.provider === 'Dlv' || game.provider === 'Endorphina' || game.provider === 'KAGaming')
      .map(game => ({
        isMobile: game.is_mobile,
        imageUrl: game.image,
        tab: filterTab(game, getTab(game.type, game.uuid)),
        gameId: game.uuid,
        provider: game.provider,
        description: game.name,
        type: CasinoType.slots,
        gameName: game.name,
        routeProvider: 'slotegrator',
        isLiveGame: game.provider.toLowerCase() === 'vivogaming',
        id: `${game.uuid}_${game.provider}`,
        haveTwoVersion: haveTwoVersions(game),
      }))
      .filter(game => game.provider.toLowerCase() !== 'betradar')
      .filter(game => {
        if (game.haveTwoVersion) return platform === 'mobile' ? game.isMobile === 1 : game.isMobile === 0;
        return true;
      });
  };

  convertGameUrl = ({ data }: IGetGameUrl<ISlotegratorGetGameUrl, unknown>) => data.url;
}
export default Converter;
